module.exports = __webpack_public_path__ + "static/media/undraw_apps_re_ienc.3f4baeb6.png";